
const newModel = () => {
    return {
        benXeId: null,
        ten: null,
        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,
        diaChi: null,
        gpsLong: null,
        gpsLat: null,
        sdt: null,
        nhaXe: null,
        tuyenDuong: null,
        web: null,
        ghiChu: null,
        stt: null,
        enabled: null,
        dateCreated: null,
        userCreated: null,
        dateModified: null,
        userModified: null,
        isDeleted: null,
        userDeleted: null,
        dateDeleted: null,
        tenUserCreated: null,
        tenUserModified: null,
        tenUserDeleted: null
    }
}

const newFEModel = () => {
    return {
        benXeId: null,
        ten: null,
        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,
        diaChi: null,
        gpsLong: null,
        gpsLat: null,
        sdt: null,
        nhaXe: null,
        tuyenDuong: null,
        web: null,
        ghiChu: null,
        stt: "0",
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        benXeId: item.benXeId,
        ten: item.ten,
        hinhAnh: item.hinhAnh,
        linkHinhAnh: item.linkHinhAnh,
        tenFileHinhAnh: item.tenFileHinhAnh,
        diaChi: item.diaChi,
        gpsLong: item.gpsLong,
        gpsLat: item.gpsLat,
        sdt: item.sdt,
        nhaXe: item.nhaXe,
        tuyenDuong: item.tuyenDuong,
        web: item.web,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted
    }
}

const parseModeltoFEModel = (item) => {
    return {
        benXeId: item.benXeId,
        ten: item.ten,
        hinhAnh: item.hinhAnh,
        linkHinhAnh: item.linkHinhAnh,
        tenFileHinhAnh: item.tenFileHinhAnh,
        diaChi: item.diaChi,
        gpsLong: item.gpsLong,
        gpsLat: item.gpsLat,
        sdt: item.sdt,
        nhaXe: item.nhaXe,
        tuyenDuong: item.tuyenDuong,
        web: item.web,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        ten: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        ten: item.ten,
        enabled: item.enabled,
    }
}


const errors = () => {
    return {
        benXeId: null,
        ten: null,
        diaChi: null,
        gpsLong: null,
        gpsLat: null,
        sdt: null,
        nhaXe: null,
        tuyenDuong: null,
        web: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

export const benXeModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    newPagingSearchModel,
    newSearchModel,
    fromJson,
    errors,
}


